import { differenceInSeconds } from 'date-fns';
import { AvlEvent } from '@sharedtypes/models';
import eventTypes from '../helpers/eventTypes';
import { handleError } from './utils/errorHandler';

/**
 * @param {AvlEvent[]} events - avlEvents newest to oldest
 * @returns {AvlEvent[]} - sorted events
 */
export default function processOutOfRegen(events:AvlEvent[]):AvlEvent[] {
  let lastRegenOn:AvlEvent | null = null;

  /**
   * Process from newest to oldest
   * If current event is regen off and last regen event was regen on
   * and its time stamp was less than a second ago swap them
   * Else if the event type if regen on - set last regen on
   */
  events.forEach((event) => {
    try {
      if (event.eventType === eventTypes.REGENON) {
      // If Regen On event, update lastRegenOn timestamp
        lastRegenOn = event;
      } else if (event.eventType === eventTypes.REGENOFF) {
      // If there is a previous Regen On event
        if (lastRegenOn) {
          const diffMilliseconds = differenceInSeconds(lastRegenOn.eventTime, event.eventTime);

          if (diffMilliseconds <= 10) {
          // Swap events
            const tempTime = event.eventTime;
             
            event.eventTime = lastRegenOn.eventTime;
            lastRegenOn.eventTime = tempTime;
            console.log('Swapping timestamps');
          }
        }
      }
    } catch (error) {
      handleError(error, 'eventStreamCorrection.processOutOfRegen');
    }
  });
  // resort the array based on timestamp after swapping oldest to newest
  events.sort((a, b) => new Date(b.eventTime).getTime() - new Date(a.eventTime).getTime());

  return events;
}
